module.exports = __webpack_public_path__ + "img/logo.17d0cd29.png";